module.exports = __webpack_public_path__ + "img/osteon-logo.10e05692.png";